import {
  CustomActionDefinition,
  EntityAcl,
  EntityContext,
  EntityModel,
  FormModel,
  FormVisibility,
} from '@msdk/definitions'

export function enableEdit(formMode: string, acl: EntityAcl): boolean {
  return formIsReadonlyMode(formMode) && acl.canUpdate
}

export function enableDeactivate(
  formMode: string,
  acl: EntityAcl,
  entity: EntityContext,
  formModel: FormModel,
  model: EntityModel,
): boolean {
  return (
    formIsReadonlyMode(formMode) &&
    entity.fields['ENTITY_STATUS']?.value === 'ACTIVE' &&
    entity.IsPersisted &&
    acl.canDeactivate &&
    formModel.canBeDeactivated &&
    model.canBeDeactivated
  )
}

export function enableActivate(formMode: string, entity: EntityContext, acl: EntityAcl): boolean {
  return formIsReadonlyMode(formMode) && entity.fields['ENTITY_STATUS']?.value !== 'ACTIVE' && acl.canActivate
}

export function enableDelete(formMode: string, entity: EntityContext, acl: EntityAcl, model: EntityModel): boolean {
  return (
    formIsReadonlyMode(formMode) &&
    entity.fields['ENTITY_STATUS']?.value !== 'ACTIVE' &&
    acl.canDelete &&
    model.canBeDeleted
  )
}

export function filterFormActions(formMode: string, actions: CustomActionDefinition[] = []): CustomActionDefinition[] {
  return formIsReadonlyMode(formMode) ? actions.filter((a) => a.actionType === 'FormButton') : []
}

export function filterCustomActions(
  formMode: string,
  actions: CustomActionDefinition[] = [],
): CustomActionDefinition[] {
  return actions.filter((a) => a.actionType === 'CustomAction' && checkVisibility(a.formVisibility, formMode))
}

function checkVisibility(formVisibility: FormVisibility, formMode: string) {
  const isReadonly = formIsReadonlyMode(formMode)
  if (isReadonly) {
    return formVisibility === FormVisibility.Readonly || formVisibility === FormVisibility.Both
  } else {
    return formVisibility === FormVisibility.Edit || formVisibility === FormVisibility.Both
  }
}

function formIsReadonlyMode(formMode: string): boolean {
  return formMode === 'Readonly'
}
